export default "__VITE_ASSET__CevcRXat__"